import React, {Component} from 'react';
import ShowTipoSoggetto from '../rubrica/ShowTipoSoggetto'
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'

class ReportSoggettiRowView extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let c = this.props.item;

        return (
            <div className="content">
                <div className="ui grid">
                    <div className="row">
                        <div className="eight wide column">
                            <label>Organizzazione</label>{c.idDipartimento.idOrganizzazione.nomeCompleto}
                        </div>
                        <div className="eight wide column">
                            <label>Dipartimento</label>{c.idDipartimento.nomeCompleto}
                        </div>
                    </div>
                    <div className="row">
                        <div className="six wide column">
                            <label>Nome</label>{c.nomeCognome}
                        </div>
                        <div className="two wide column">
                            <label>Sesso</label>{c.sesso}
                        </div>
                        <div className="four wide column">
                            <label>C.F.</label>{c.cfisc}
                        </div>
                        <div className="four wide column">
                            <label>Tipo</label><ShowTipoSoggetto soggetto={c}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="five wide column"><label>Indirizzo</label>{c.indirizzo}</div>
                        <div className="two wide column">
                            <label>CAP</label>{c.cap}
                        </div>
                        <div className="four wide column">
                            <label>Città</label>{c.citta}
                        </div>
                        <div className="two wide column">
                            <label>Provincia</label>{c.provincia}
                        </div>
                        <div className="three wide column">
                            <label>Stato</label>{c.stato}
                        </div>
                    </div>
                    <div className="row">
                        <div className="four wide column">
                            <label>e-mail</label>{c.email}
                        </div>
                        <div className="three wide column">
                            <label>PEC</label>{c.pec}
                        </div>
                        <div className="three wide column">
                            <label>Cellulare</label>{c.cellulare}
                        </div>
                        <div className="two wide column">
                            <label>Telefono 1</label>{c.tel1}
                        </div>
                        <div className="two wide column">
                            <label>Telefono 2</label>{c.tel2}
                        </div>
                        <div className="two wide column">
                            <label>FAX</label>{c.fax}
                        </div>

                    </div>
                    <div className="row">
                        <div className="four wide column">
                            <label>Creato il</label>{c.creatoIl ?  <b><LocalDate data={c.creatoIl } /> <LocalTime data={c.creatoIl } /></b> : <b>?</b>}
                        </div>
                        <div className="four wide column">
                            <label>Da</label>{c.creatoDa ? c.creatoDa.username : '?'}
                        </div>
                        <div className="four wide column">
                            <label>Modificato il</label>
                            {c.modificatoIl ?  <LocalDate data={c.modificatoIl } /> : '?'}
                            &nbsp;
                            {c.modificatoIl ?  <LocalTime data={c.modificatoIl } /> : null}
                        </div>
                        <div className="four wide column">
                            <label>Da</label>{c.modificatoDa ? c.modificatoDa.username : '?'}
                        </div>
                    </div>
                    <div className="row">
                        <div className="sixteen wide column"><label>Note</label>{c.note}</div>
                    </div>

                </div>
            </div>
        )
    }
}




export default ReportSoggettiRowView;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportSoggettiRowView.js
 **/